module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (66).f326460e.jpg";